import { Pipe, PipeTransform } from '@angular/core';
import { CredentialStatus, CredentialStatusTranslation } from '../model/dictionary/CredentialStatus';
import { Strings } from '../language/strings';

@Pipe({
  name: 'credentialStatus'
})
export class CredentialStatusPipe implements PipeTransform {

  constructor(private strings: Strings) {}

  transform(value: number): string {
    return this.strings.GetText(CredentialStatusTranslation[value]);
  }
}
